// @flow

import { API_ENDPOINT } from 'shared/config';

import type { CurrentUser } from 'types/CurrentUser';

export const currentBorrower = (): Promise<CurrentUser | null> =>
  fetch(`${API_ENDPOINT}/users/me`, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((res) => {
    if (res.status === 401) return null;

    if (!res.ok) throw res;

    return res.json();
  });

export default currentBorrower;
